/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamMembershipRequestSchema } from './teamMembershipRequestSchema';

export const membershipBulkAddRequestSchema = z.object({
  get memberships() {
    return z.array(teamMembershipRequestSchema).min(1);
  },
});
